let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7IeB1")).then(() => parcelRequire('SijLP'));